import React, { useState } from "react";
import Overlay from "../Overlay";
import { COMMERCIAL_TERMS_DETAIL } from "../../data/commercialTerms";
import { responsiveImage } from "../../utils/responsiveImage";

const ARTE_WIDTHS = [640, 960, 1280, 1672];
const arte = responsiveImage("/assets/home/beneficios-distribuidores", ARTE_WIDTHS);

/**
 * Beneficios para distribuidores.
 *
 * Por ahora la sección es la pieza que entregó diseño, entera: el titular, las
 * tres condiciones y el botón están dentro de la imagen. La imagen completa es
 * el disparador del modal, así que el "Ver condiciones comerciales" dibujado
 * funciona igual que un botón real.
 *
 * Como el texto es parte de la imagen, el `alt` lleva el contenido para que
 * lectores de pantalla y buscadores lo tengan.
 *
 * Se muestra debajo de las promociones y solo con sesión iniciada.
 */
const ALT = "Beneficios para distribuidores: 25% por condición de distribuidor, "
	+ "+5% por mantener la cuenta al día y +5% por volumen de compra. "
	+ "Los descuentos aplican según la condición comercial de cada cuenta, sujeto a vigencia y estado de cuenta.";

const DistributorTerms = () => {

	const [isOpen, setIsOpen] = useState(false);

	return (
		<section id="distribuidores" className="anchor-target bg-[#fbf5f0] py-10 lg:py-14">
			<div className="shell">
				<button
					type="button"
					onClick={ () => setIsOpen(true) }
					aria-label="Ver condiciones comerciales para distribuidores"
					className="block w-full overflow-hidden transition-shadow duration-300 hover:shadow-card"
				>
					<img
						src={ arte.src }
						srcSet={ arte.srcSet }
						sizes="(min-width: 1360px) 1296px, 100vw"
						alt={ ALT }
						width="1672"
						height="941"
						loading="lazy"
						className="h-auto w-full"
					/>
				</button>
			</div>

			{
				isOpen &&
					<Overlay label="Condiciones comerciales" onClose={ () => setIsOpen(false) }>
						<div className="relative w-full max-w-[600px] bg-white px-6 pb-8 pt-10 shadow-[0_40px_120px_rgba(0,0,0,.35)] sm:px-11 sm:pb-11">
							<button
								type="button"
								onClick={ () => setIsOpen(false) }
								aria-label="Cerrar"
								className="absolute right-3 top-3 h-10 w-10 text-3xl font-extralight text-muted transition-colors duration-200 hover:text-ink"
							>
								×
							</button>

							<p className="eyebrow">Distribuidores</p>
							<h2 className="mb-5 mt-3.5 text-[28px] font-semibold leading-tight tracking-headline sm:text-[34px]">
								Condiciones comerciales
							</h2>

							<ul className="m-0 list-disc p-0 pl-5">
								{
									COMMERCIAL_TERMS_DETAIL.map((line, index) => (
										<li key={ index } className="mt-2 text-sm leading-relaxed text-muted">{ line }</li>
									))
								}
							</ul>
						</div>
					</Overlay>
			}
		</section>
	);
};

export default DistributorTerms;
